import * as firebase from 'firebase/app';
import 'firebase/firestore';
import { toDateFormat } from 'utils/date';
import { TIMELINE } from 'utils/constants/collectionNames';
import { TIMELINE_TYPES, TIMELINE_LIMIT } from 'utils/constants/timeline';
import {
  GET_TODAY_TIMELINE_SUCCEED,
  GET_TODAY_TIMELINE_ERROR,
  GET_CLIENT_TIMELINE_SUCCEED,
  GET_CLIENT_TIMELINE_ERROR,
  CLEAR_CLIENT_TIMELINE_STATE,
  LOADING_STATE
} from './types';

// fetch today events of trainer from Firebase
export const getTodayTimeline = () => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let todayBeginning = new Date();
    todayBeginning.setHours(0, 0, 0, 0);

    dispatch({
      type: LOADING_STATE
    });
    let queryRef = firestore
      .collection(TIMELINE)
      .where('trainer_id', '==', firebase.auth().currentUser.uid)
      .where('created_at', '>=', todayBeginning)
      .orderBy('created_at', 'desc');
    return queryRef.onSnapshot(querySnapshot => {
      let sessions = {};

      const events =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          let obj = doc.data();
          obj.created_at = toDateFormat(obj.created_at);
          if (obj.type === TIMELINE_TYPES.TRAINER_LOGS_WORKOUT) {
            sessions[obj.client_id] = true;
          }
          return {
            ...obj,
            id: doc.id
          };
        });
      dispatch({
        type: GET_TODAY_TIMELINE_SUCCEED,
        payload: {
          numberOfSessions: Object.keys(sessions).length,
          events
        }
      });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_TODAY_TIMELINE_ERROR,
      payload: `error: ${err}`
    });
  }
};

// fetch client timeline from Firebase
export const getClientTimeline = (
  clientId,
  lastVisible,
  isLoadMore
) => async dispatch => {
  try {
    let firestore = firebase.firestore();
    let queryRef = {};

    dispatch({
      type: LOADING_STATE
    });
    if (isLoadMore) {
      queryRef = firestore
        .collection(TIMELINE)
        .where('trainer_id', '==', firebase.auth().currentUser.uid)
        .where('client_id', '==', clientId)
        .orderBy('created_at', 'desc')
        .startAfter(lastVisible)
        .limit(TIMELINE_LIMIT);
    } else {
      queryRef = firestore
        .collection(TIMELINE)
        .where('trainer_id', '==', firebase.auth().currentUser.uid)
        .where('client_id', '==', clientId)
        .orderBy('created_at', 'desc')
        .limit(TIMELINE_LIMIT);

      dispatch({
        type: CLEAR_CLIENT_TIMELINE_STATE,
        payload: { events: [], lastVisible: null, hasMore: false }
      });
    }

    return queryRef.onSnapshot(querySnapshot => {
      const events =
        querySnapshot.docs &&
        querySnapshot.docs.map(doc => {
          let obj = doc.data();
          obj.created_at = toDateFormat(obj.created_at);
          return {
            ...obj,
            id: doc.id
          };
        });
      const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
      const hasMore = events.length === TIMELINE_LIMIT;

      dispatch({
        type: GET_CLIENT_TIMELINE_SUCCEED,
        payload: { events, lastVisible, hasMore, isLoadMore }
      });
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_CLIENT_TIMELINE_ERROR,
      payload: `error: ${err}`
    });
  }
};
